export const USERS = "/users";
export const REGISTER = "/register";
export const VERIFY_OTP = "/verify-otp";
export const RESEND_OTP = "/resend-otp";
export const SET_PIN = "/set-pin";
export const LOGIN = "/login";
export const FORGOT_PIN = "/forgot-pin";
export const RESET_PIN = "/reset-pin";
export const CHANGE_PIN = "/change-pin";
export const BOOKING = "/booking";
export const BOOKING_LIST = "/empBookingList";
export const EMP = "/emp";
export const PROFILE = "/profile";
export const DESTINATION = "/AmdDestinantion";
export const LOCATION = "location";
export const CREATE_BOOKING = "/createBooking";
export const CANCEL_BOOKING = "/cancelBooking";
export const SETTINGS = "/settings";
export const BALANCE = "/getBalance";
export const AAD_LOGIN = "/aadlogin";
export const UPLOAD_DOCUMENTS = "/uploadDocuments";
export const PASSPORT = "/passport";
export const PUSH = "/push";
export const PUSH_NOTIFICATION = "/push/notification";
export const SET_VIDEO = "/users/setVideoFlag";
export const API_VERSION = "/api/v1";
